export enum NavType {
  Public,
  Member
}
